// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v8 — see `ChannelModifier.schema_version`.
 *
 * What one step of a modifier's expected sequence does.
 *   `WAIT` (0)      — wait for an observed change: every pre-v8 step. MUST stay
 *                     0, because a pre-v8 step reads this field as its default.
 *   `RELEASE` (1)   — send the held source command. Steps after it run after the
 *                     release, without holding the source channel's loop.
 *   `SEND` (2)      — send a message to a channel and wait for it to be written.
 *   `AWAIT_ACK` (3) — wait for the controller's acknowledgement of the released
 *                     command. Only after `RELEASE`.
 * Values are APPEND-ONLY.
 */
export enum SequenceStepKind {
  WAIT = 0,
  RELEASE = 1,
  SEND = 2,
  AWAIT_ACK = 3,
}
